import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as NavigationRightIcon } from '@repo/common/assets/icons/16px/icon_16px_navigation-right.svg';
import { BaseButton, useIsMobile, useT } from '@repo/common';

const photoImg = `${process.env.REACT_APP_ASSETS_URL}/JobBoard/jobboard_banner_photo.png`;
const airplaneImg = `${process.env.REACT_APP_ASSETS_URL}/JobBoard/jobboard_banner_airplane.svg`;
const skyImg = `${process.env.REACT_APP_ASSETS_URL}/JobBoard/img-banner-sky.svg`;

export const KpathportInlineBanner = ({ className = '' }) => {
  const t = useT();
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const goToPathfinder = () => navigate('/pathfinder');

  return (
    <div
      role='button'
      tabIndex={0}
      onClick={goToPathfinder}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          goToPathfinder();
        }
      }}
      className={`
        relative flex w-full shrink-0 cursor-pointer items-center justify-between gap-2
        overflow-hidden rounded-[15px] border border-grayscale-gray02 bg-green-light01
        px-6 py-[18px] transition-colors duration-200
        tabletH:rounded-lg tabletH:p-6
        ${className}
      `}
    >
      <img
        alt=''
        aria-hidden='true'
        src={skyImg}
        className='pointer-events-none absolute inset-0 h-full w-full object-cover'
      />
      <span
        aria-hidden='true'
        className='pointer-events-none absolute inset-0'
        style={{ backgroundColor: 'rgba(245, 244, 244, 0.80)' }}
      />

      <p className='typo-b16Strong tabletH:typo-title3 relative z-10 min-w-0 flex-1 text-text-primary'>
        {t('Career gap diagnosis, Pathfinder', '커리어 갭 진단, 패스파인더')}
      </p>

      <BaseButton
        type='text'
        size='s'
        hideIcon
        bgclass='relative z-10 shrink-0 border-transparent ring-transparent bg-surface-lightgray80 text-text-tertiary'
        onClick={(e) => {
          e.stopPropagation();
          goToPathfinder();
        }}
      >
        {isMobile
          ? t('Start free', '무료로 시작하기')
          : t('Start Pathfinder', '패스파인더 시작하기')}
      </BaseButton>
    </div>
  );
};

const KpathportBanner = () => {
  const navigate = useNavigate();

  return (
    <div className='flex w-full flex-col items-start gap-5 overflow-hidden rounded-[20px] border-[1.6px] border-grayscale-gray02 bg-grayscale-gray00 p-5 tabletV:gap-4 tabletV:rounded-[8px] tabletV:p-4'>
      <div className='relative h-[200px] w-full shrink-0 tabletV:h-[160px]'>
        <img
          alt=''
          className='absolute inset-[-5%_-4.96%_-10%_-4.96%] block size-full max-w-none'
          src={photoImg}
        />
      </div>

      <div className='flex w-full flex-col items-start gap-3'>
        <div
          className='flex w-full items-start gap-px'
          role='img'
          aria-label='Pathfinder'
        >
          <p className='whitespace-nowrap text-[44px] font-semibold leading-none tracking-[-1.32px] text-green-deep04 tabletV:text-[34px] tabletV:tracking-[-1.02px]'>
            PATH
          </p>
          <div className='shrink-0 pt-[7px] tabletV:pt-[5px]'>
            <img
              alt=''
              className='h-[32px] w-[34px] tabletV:h-[25px] tabletV:w-[26px]'
              src={airplaneImg}
            />
          </div>
          <p className='whitespace-nowrap text-[44px] font-semibold leading-none tracking-[-1.32px] text-green-deep04 tabletV:text-[34px] tabletV:tracking-[-1.02px]'>
            FINDER
          </p>
        </div>

        <div className='flex w-full items-center gap-3 tabletV:flex-col tabletV:items-start'>
          <p className='typo-b16Strong min-w-0 flex-1 tabletV:typo-b12Strong tabletV:w-full tabletV:flex-none'>
            <span className='text-green-deep04'>Career gap</span>
            <span className='text-grayscale-gray04'> diagnosis </span>
            <br />
            <span className='text-grayscale-gray04'>and </span>
            <span className='text-green-deep04'>skill support</span>
          </p>

          <BaseButton
            type='text'
            size='s'
            typo={false}
            isStatic
            leftalign
            onClick={() => navigate('/community/kpathport/pathfeed')}
            icon={
              <span className='flex size-9 shrink-0 items-center justify-center rounded-full bg-grayscale-gray01 text-green-deep04 tabletV:size-[27px]'>
                <NavigationRightIcon className='-rotate-45 transition-transform duration-200 group-hover:rotate-0' />
              </span>
            }
            iconPosition='after'
            gap='gap-2'
            className='group h-auto min-w-0 shrink-0 cursor-pointer rounded-none border-0 bg-transparent p-0 tabletV:w-full [&>span]:items-center [&>span]:justify-end'
            textWrapperClass='typo-b16Strong h-auto whitespace-nowrap text-green-deep04 group-hover:underline tabletV:typo-b12Strong tabletV:min-w-0 tabletV:flex-1 tabletV:text-left'
          >
            Explore more
          </BaseButton>
        </div>
      </div>
    </div>
  );
};

export default KpathportBanner;
